import { Component, OnInit, OnDestroy, HostListener, Injector, ApplicationRef, ElementRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ViewsService } from "@app/services/views.service";
import { ActivatedRoute, Router } from '@angular/router';
import { ChildLoadingService } from '@app/services/child-loading.service';
import { CourseService } from '@scaffold/services/course.service';
import { WebsocketService } from '@services/websocket.service';
import { NotificationsService, NotificationItem } from '@services/notifications.service';
import { MoveItemService } from '@scaffold/services/move-item.service';
import { ConfirmDialog } from '@generic/confirm-dialog/confirm-dialog.component';
import { SaveDialogComponent } from '@generic/save-dialog/save-dialog.component';
import { UpdatingStatusService } from '@services/updating-status.service';
import * as moment from 'moment';
import { UserService } from '@services/user.service';
import { environment } from '@env/environment';
import { ItemsService } from '@scaffold/services/items.service';
import { ViewUpdateService } from '@scaffold/services/view-update.service';
import { PendingChangesGuard } from '@app/shared/pending-changes.guard';
import { Observable, of, Subject, Subscription } from 'rxjs';
import { VersionControlService } from '@scaffold/services/version-control.service';
import { take, filter, map, takeUntil, catchError } from 'rxjs/operators';
import { PropertiesService } from '@scaffold/services/properties.service';
import { NbDialogService, NbMenuItem, NbMenuService, NbMenuBag, NbDialogRef } from '@nebular/theme';
import { ScaffoldSidebarService } from '@services/scaffold-sidebar.service';
import { VersionSidebarComponent } from '@scaffold/sidebars/version-control/version-sidebar/version-sidebar.component';
import { SyncService } from '@scaffold/services/sync.service';
import { IframeService } from '@services/iframe.service';
import { EnvironmentService } from '@services/environment.service';
import { TranslationService } from '@services/translation.service';
import { PageTitleService } from '@services/page-title.service';

@Component({
  selector: 'app-view-frame',
  templateUrl: './view-frame.component.html',
  styleUrls: ['./view-frame.component.scss']
})
export class ViewFrameComponent implements OnInit, OnDestroy, PendingChangesGuard {
  @HostListener('window:unload', ['$event'])
  unloadHandler (event) {
    if (this.itemsService.autosave) {
      this.itemsService.saveData().subscribe();
    }
  }
  //@HostListener('window:beforeunload')
  canDeactivate (): Observable<boolean> | boolean {
    let disableSave = this.itemsService.disableSave(false);
    console.log(disableSave);
    if (disableSave) {
      
      const text = this.translationService.getTranslatedContent("there_is_an_error_in_the_input_lingo","There is an error in the input, please correct to allow saving!");
      this.notifications.popNotification(text, "", 5, { status: "danger", position: 'top-begin', hasIcon: true, icon: { pack: 'fas', icon: 'exclamation-triangle' } });
      return false;
    }
    if (this.checkKeys(this.view_data) && this.allowDeactivate) {
      let choice: Subject<boolean> = new Subject<boolean>();
      if (this.itemsService.autosave) {
        this.isSaving = true;
        this.properties.setProperties(null);
        this.itemsService.saveData().subscribe(d => {
          console.log("complete");
          this.isSaving = false;
          choice.next(true);

        });
      } else {
        let settings: any = {
          context: {
            data: {
              title: this.translationService.getTranslatedContent('unsaved_changes',"Unsaved Changes"),
              message:this.translationService.getTranslatedContent('there_may_be_unsaved_changes_in_this_view_lingo',"There may be unsaved changes in this view, Would you like to save?")
            }
          }
        };
        var dialogRef = this.dialog.open(SaveDialogComponent, settings);

        dialogRef.onClose.subscribe(result => {
          if (result) {
            if (result === 'save') {
              this.isSaving = true;
              this.properties.setProperties(null);
              this.itemsService.saveData().subscribe(d => {
                console.log("complete");
                this.isSaving = false;
                choice.next(true);

              });
            } else {
              this.properties.setProperties(null);
              this.view_data = {};
              this.itemsService.cancelData(true);
              this.isSaving = false;;
              choice.next(true);
            }

          } else {
            this.isSaving = false;
            choice.next(false);
          }

        });
      }
      return choice;
    } else {
      return true;
    }
  }

  constructor (
    private translationService:TranslationService,
    public syncService: SyncService,
    public viewService: ViewsService,
    private route: ActivatedRoute,
    public router: Router,
    public loading: ChildLoadingService,
    private courseService: CourseService,
    private socketService: WebsocketService,
    private notifications: NotificationsService,
    public movingItem: MoveItemService,
    private dialog: NbDialogService,
    public updateStatusService: UpdatingStatusService,
    private userService: UserService,
    private itemsService: ItemsService,
    private pageTitleService:PageTitleService,
    private viewUpdate: ViewUpdateService,
    private applicationRef: ApplicationRef,
    injector: Injector,
    private environmentService: EnvironmentService,
    private nbMenuService: NbMenuService,
    private versioning: VersionControlService,
    private properties: PropertiesService,
    public iframeService: IframeService,
    private sidebar: ScaffoldSidebarService) {
    this.appElementRef = applicationRef.components[0].injector.get(ElementRef);
  }
  /*
<button mat-menu-item (click)="push(true)" [disabled]="isSyncDisabled()">
        <span>Sync Child Course to LMS</span>
      </button>
      <button mat-menu-item (click)='pushToChildren()' [disabled]="syncingChild || isSyncDisabled()">
        <span>Push Updates to Child Courses</span>
*/
  menu: NbMenuItem[] = [

    { title: "Push Updates to Child Courses", data: { action: 'pushToChildren' } }, { title: "Sync Child Course to LMS", data: { action: 'push' } }
  ];

  savemenu: NbMenuItem[] = [
  /*  { title: "Disable Autosave", hidden: !this.itemsService.autosave || !this.itemsService.autosave, data: { action: 'disableAutoSave' } },
    { title: "Enable Autosave", hidden: this.itemsService.autosave || !this.itemsService.autosave, data: { action: 'enableAutoSave' } },
  */  { title: "Cancel Changes", data: { action: 'cancel' } }];

  syncmenu: NbMenuItem[] = [
  /*  { title: "Disable Autosave", hidden: !this.itemsService.autosave || !this.itemsService.autosave, data: { action: 'disableAutoSave' } },
    { title: "Enable Autosave", hidden: this.itemsService.autosave || !this.itemsService.autosave, data: { action: 'enableAutoSave' } },
  */  { title: "Restore Course", data: { action: 'restore' } }];

  courseLoad: Subscription;
  identifier = "menu-" + Math.floor(Math.random() * 5000);
  isSaving = false;
  allowDeactivate = true;
  type: string = "";
  id: any;
  mode: string;
  course_id: any;
  course;
  view_data: any;
  view;
  showEdit;
  parent;
  destroy$: Subject<boolean> = new Subject<boolean>();
  version;
  versionMessage: NotificationItem;
  versionSidebar: NbDialogRef<VersionSidebarComponent>;
  showVersions = true;
  showVersionPanel = false;
  updateSocket;
  trackUpdates = false;
  socketExpiration;
  socketConnectionId;
  isRoot;
  syncing;
  syncingChild;
  disableSync = false;
  disableSave = false;
  overriddenView = false;
  private _lastSaveVisible;
  appElementRef: ElementRef;
  htmlContent;
  notFoundError = false;
  instanceDetails;
  ngOnInit () {

    this.nbMenuService.onItemClick().pipe(
      takeUntil(this.destroy$),
      filter(({ tag }) => tag === this.identifier),
      map(({ item: { data } }) => data.action),
    ).subscribe(action => {
      console.log(action);
      switch (action) {
        case 'push':
          this.push(true);
          break;
        case 'restore':
          this.restore();
          break;
        case 'pushToChildren':
          this.pushToChildren();
          break;
        case 'disableAutoSave':
          this.itemsService.autosave = false;
          this.savemenu[0].hidden = true;
          this.savemenu[1].hidden = false;
          break;
        case 'enableAutoSave':
          this.itemsService.autosave = true;
          this.savemenu[0].hidden = false;
          this.savemenu[1].hidden = true;
          break;
        case 'cancel':
          this.cancel();
          break;
        default:
          break;

      }
    });


    this.userService.getRoleDetails().pipe(take(1)).subscribe(user => {
      this.disableSync = user.disable_sync;
      this.disableSave = user.prevent_edit;
    });
    this.environmentService.getInstanceDetails().pipe(
      takeUntil(this.destroy$)).subscribe(details => {
      this.instanceDetails = details;
    })
    this.version = this.versioning.currentVersion;
    console.log(this);
    this.loading.startLoading();
    this.route
      .data.pipe(takeUntil(this.destroy$))
      .subscribe(v => {
        console.log(v);
        this.showEdit = v.allow_edit;
        this.isRoot = v.root;
        console.log("Reset course if in view:", this.isRoot, this.showEdit);
        //TEMP check if the route hase a childe and if this is the reed view frame. if so disable the save navigation popup and let the child view frame handle it.
        //This prevent duplicat popups
        let disableNavCheck;
        try {
          let url = this.router.routerState.snapshot.url.split(/\//g);
          console.log(url);
          if (url.length > 2)
            disableNavCheck = true;
          console.log(this.router.routerState.snapshot);
        } catch (e) {
          console.log(e);
        }
        if (this.isRoot && disableNavCheck) {
          this.allowDeactivate = false;
        }
        if (this.isRoot && (this.showEdit || this.type !== 'courses')) {
          this.courseService.id = null;
          this.versioning.currentVersion = null;
          this.versioning.watchVersion().pipe(takeUntil(this.destroy$)).subscribe(v => {
            console.trace("Set Version", v);
            this.version = v;
            this.getViews();
          });
        }
      });

    var hasSelf = false;
    var hasParent = false;


    this.route.paramMap.pipe(takeUntil(this.destroy$)).subscribe(p => {
      console.log(p);
      this.view_data = {};
      this.id = p.get('id');
      this.itemsService.getData(this.id);
      this.type = p.get('type') || 'views';
      this.appElementRef.nativeElement.scrollTop = 0;
      if (this.type === 'courses') {
        if (this.courseService.id != this.id)
          this.versioning.currentVersion = null;
        this.courseService.id = this.id;
      }
      if (this.router.url.indexOf('/files') > 0) {
        this.showVersions = false;
      } else {
        //Temp disable versioning
        this.showVersions = false;//true;
      }
      hasSelf = true;
      if (hasSelf && hasParent) {
        this.getViews();
      }
      //trigger update for navigation rendered item
      this.viewUpdate.routeUpdated(p);
    });



    this.route.parent.params.pipe(takeUntil(this.destroy$)).subscribe(parent => {
      this.parent = parent;

      hasParent = true;
      console.log(this);
      if (hasSelf && hasParent) {
        this.getViews();
      }
      //trigger update for navigation rendered item
      this.viewUpdate.routeUpdated(parent);
    });


  }



  log () {
    console.log(this.itemsService);
  }

  public setTitle (newTitle: string) {
    this.pageTitleService.section = newTitle||'';
  }



  isSyncDisabled () {

    return this.showPageButtons() || this.isSaving || this.versioning.currentVersion || this.disableSync;
  }

  isSaveDisabled () {

    return this.hasErrors(this.view_data) || !this.checkKeys(this.view_data) || !this.showPageButtons() || this.versioning.currentVersion || this.disableSave || this.isSaving;
  }

  private getViews () {
    let viewUrl = '';
    this.view_data = {};
    if (this.type && this.id) {
      viewUrl += this.type + "/" + this.id + "?mode=read";



      if (this.type == 'courses') {
        // Cancel prev subscription
        this.trackUpdates = true;
        if (this.updateSocket) {
          this.updateSocket.unsubscribe();
        }

        // Reset Connection just in case it was prev open and we're switching courses
        this.resetSocket();

        // Setup listener to refresh connection
        this.socketService.classRefresh.pipe(takeUntil(this.destroy$)).subscribe(() => { this.refreshSocket(); });

        //remove data stored in ItemsService when loading new course
        this.itemsService.cancelData(true);

      }

    } else {
      if (this.parent.type && this.parent.id) {
        viewUrl = this.parent.type + "/" + this.parent.id;
      }
      // Just a type in current url? parent views mode?
      viewUrl += "?mode=" + this.type;
    }
    if (this.version) {
      viewUrl += "&version=" + this.version;
    }
    this.view = { loading: true };
    //Cancel loading of view if another route ic cliked mid-load
    if (this.courseLoad?.unsubscribe) {
      this.courseLoad.unsubscribe();
    }
    this.courseLoad = this.courseService.get(viewUrl).pipe(take(1)).pipe(catchError((error) => of({ error }))).subscribe(co => {
      const isEmptyObject = typeof co==='object'&&Object.keys(co||{}).length===0
      if (co.html) {
        this.htmlContent = co.html;
      } else {
        if (co&&!isEmptyObject) {
          this.notFoundError = false;
          if (co[0]) {
            co = co[0];
          }
          if (co.Event?.match(/Invalid ID/i)||isEmptyObject) {
            this.notFound();
            return;
          }
          this.view = co;
          if (this.view.view_details)
            this.courseService.setTitle(this.view.view_details.mode, this.view.view_details.title, this.view.type);
          //if this is the root view frame, set the page title based on thew title or type of data item loaded
          if (this.isRoot) {
            this.setTitle(co.title || co.type);
            if (environment.isOPM && co.institution_id) {
              this.courseService.setPartnerId(co.institution_id);
            }
          }

          this.overriddenView = this.showEdit && (environment.opmReference != null) && (co.institution_id != environment.opmReference);
        } else {
          // set 404 not found to true
          this.view = null;
          this.notFound();
        }
      }
      this.loading.endLoading();
      this.viewUpdate.routeUpdated({ type: 'view updated', root_title: co.title || co.type });
    });
  }

  notFound () {
    console.log("NOT FOUND");
    this.pageTitleService.section ="Not Found";
    this.view = null;
    this.notFoundError = true;
  }

  private getContentValues (e) {
    e.forEach(comp => {
      console.log(comp);
      if (comp.type !== 'conditional' && comp.hasOwnProperty('name')) {
        if (comp.name.indexOf(".") < 0)
          this.view_data[comp.name] = comp.value;
      }
      if (comp.push) {
        this.getContentValues(comp);
      }
      if (comp.content) {
        this.getContentValues(comp.content);
      }
    });

  }
  // });

  //   if (!this.id) {
  //     this.parentSub = this.route.parent.params.subscribe(parent => {
  //       this.parent = parent;
  //       this.viewSub =  this.viewService.getViews("/" + parent.type + "/" + parent.id + "?mode=" + p.get('type')).subscribe(co => {
  //           if (co) {
  //             if (co[0]) {
  //               co = co[0]
  //             }
  //             this.view = co;

  //             this.route.queryParams.subscribe(qp => {
  //               if (qp.forwardUrl) {
  //                 this.router.navigateByUrl(this.router.parseUrl(qp.forwardUrl));
  //               }
  //             })
  //           }
  //          this.loading.endLoading();

  //       });

  //     });
  //   } else {
  //     this.parentSub = this.route.parent.params.subscribe(parent => {
  //       this.parent = parent;
  //     });
  //     this.viewSub =  this.viewService.getViews(this.router.url.split("?")[0] + "?mode=" + (this.id ? "read" : "list")).subscribe(co => {
  //       if (co) {
  //         if (co[0]) {
  //           co = co[0]
  //         }
  //         this.view = co;
  //         this.querySub =   this.route.queryParams.subscribe(qp => {
  //           if (qp.forwardUrl) {
  //             this.router.navigateByUrl(this.router.parseUrl(qp.forwardUrl));
  //           }
  //         })
  //       }
  //       this.loading.endLoading();
  //     });
  //   }


  // });
  //


  ngOnDestroy () {
    this.loading.startLoading();
    if (this.updateSocket) {
      this.socketService.close(this.socketConnectionId);
      this.updateSocket.unsubscribe();
    }
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
    if (this.isRoot && this.type === 'courses') {
      this.courseService.id = null;
      this.versioning.currentVersion = null;
      this.courseService.setPartnerId(null);
    }
    if (this.versionSidebar)
      this.versionSidebar.close();
  }

  logEdits () {

    console.log(this.view_data);
  }

  checkKeys (obj): boolean {
    /*if (obj && Object.keys(obj).length > 0) {
      var requiredToComplete = this.itemsService.checkRequired(this.view.id, obj);
      if (requiredToComplete.length == 0)
        return true;
      else
        return false;
    } else {
      return false;
    }*/
    let show = this.itemsService.showSave();
    if (show != this._lastSaveVisible) {
      console.log("SHOW SAVE");
      setTimeout(() => this.viewUpdate.triggerChangePropagation("show edit"), 500);

    }
    this._lastSaveVisible = show;
    return show;
  }

  hasErrors (obj) {
    return this.itemsService.disableSave();
  }


  editPage () {
    this.router.navigate(['edit'], { relativeTo: this.route });
  }

  cancel () {
    console.log("cancel");
    // cancel_changes /-> update this page for translations to be used instead of static text
    const translatedTitle = this.translationService.getTranslatedContent('cancel_changes',"Cancel Changes")
    let settings: any = {
      context: {
        data: {
          title: `${translatedTitle||"Cancel changes"}?`,
          message: "Are you sure you want to cancel? You will lose all unsaved progress made on this page."
        }
      }
    };
    var dialogRef = this.dialog.open(ConfirmDialog, settings);

    dialogRef.onClose.subscribe(result => {
      console.log(result);
      if (result) {
        this.properties.setProperties(null);
        this.view_data = {};
        this.itemsService.cancelData(true);
        // this.itemsService.routeUpdated('view updated');
        // this.getViews();

      }
    });
  }
  async push (children?) {
    this.syncing = "Started";
    await this.syncService.push(this.id, this.type, this.view?.title, children);
    this.syncing = undefined;
  }

  async restore () {
    this.syncing = "Started";
    await this.syncService.push(this.id, this.type, this.view?.title, null, 'restore');
    this.syncing = undefined;
  }

  // push(children?) {
  //   console.log('push children')
  //   //query string param pushUpdate triger step function to start on course
  //   let url = "/" + this.type + "/" + this.id + "?pushUpdate=true";
  //   if (children) {
  //     url += "&children=true;"
  //   }
  //   this.syncing = "Started";
  //   this.itemsService.saveViewData(url, { data: {} }).subscribe(d => {
  //     // console.log(d);
  //     if (d.executions && d.executions.length > 0) {
  //       let disp = d.executions[0];
  //       this.notifications.addUserNotification({
  //         icon:NotificationMessageIcon.fileExport,
  //         status: 'In Progess',text: `Syncing <b>${this.view?.title || this.id}</b>`, shouldForceOpen: true }, disp.executionArn);
  //       let update = setInterval(() => {
  //         let surl = "/" + this.type + "/" + this.id + "?executionArn=" + disp.executionArn;
  //         this.viewService.getViews(surl).subscribe(s => {
  //           //console.log(s)
  //           if (s.status === 'FAILED') {
  //             console.log("Failed");
  //             console.log(s);
  //             clearInterval(update);
  //             this.syncing = undefined;
  //             this.notifications.addUserNotification({
  //               icon:NotificationMessageIcon.fail,
  //               status: 'Syncing failed', text: `Syncing <b>${this.view?.title || this.id}</b> failed` , shouldForceOpen: true }, disp.executionArn);
  //           } else if (s.status === "SUCCEEDED") {
  //             console.log("completed");
  //             console.log(s);
  //             clearInterval(update);
  //             this.notifications.addUserNotification({
  //               icon:NotificationMessageIcon.checkmark,
  //               status: 'Completed', text:`Syncing <b>${this.view?.title || this.id}</b> completed` , shouldForceOpen: false }, disp.executionArn);
  //             this.syncing = undefined;
  //           } 
  //         })
  //       }, 2000)
  //     } else if (d.error) {
  //       this.notifications.addUserNotification({
  //         icon:NotificationMessageIcon.fail,
  //         status: 'Syncing failed', text:`Syncing <b>${this.view?.title || this.id}</b> failed`, shouldForceOpen: true },''+Date.now());
  //       this.syncing = undefined;
  //     } else {
  //       this.notifications.addUserNotification({
  //         icon:NotificationMessageIcon.fail,
  //         status: 'Syncing failed', text: `Syncing <b>${this.view?.title || this.id}</b> failed - No Lms Selected` , shouldForceOpen: true }, '' + Date.now());
  //       this.syncing = undefined;
  //     }
  //   });
  // }

  pushToChildren () {
    //query string param pushUpdate triger step function to start on course
    let url = "/" + this.type + "/" + this.id + "?updateChildren=true";
    this.syncingChild = this.translationService.getTranslatedContent("started","Started") ;
    this.itemsService.saveViewData(url, { data: {} }).subscribe(d => {
      this.syncingChild  = this.translationService.getTranslatedContent("completed","Completed") ; ;
      setTimeout(() => {
        this.syncingChild = null;
      }, 2000);
    });
  }


  save () {
    this.properties.setProperties(null);
    this.isSaving = true;
    this.itemsService.saveData().subscribe(d => {
      console.log(d);
      this.isSaving = false;
    });
    /* console.log(this.view_data);
     if (this.view_data && !this.showEdit && this.type != 'view') {
       delete this.view_data.data_input_error;
       delete this.view_data.view;
       this.properties.setProperties = null;

       var data = cloneDeep(this.view_data)

       var newurl = '';

       if (this.parent && this.parent.type) {
         newurl += '/' + this.parent.type + '/' + this.parent.id
       }

       if (this.id) {
         newurl += '/' + this.type + '/' + this.id
       }

       Object.keys(data).forEach(key => {
         if (typeof data[key] == 'object') {
           this.searchChildrenForDataRef(data[key]);
         }
       })

       this.viewService.saveViewData(newurl, { data: data }).subscribe(d => {
         this.view_data = {}
        // this.view = d;
         this.itemsService.routeUpdated('save');
       });
       this.view_data = {}
       this.itemsService.routeUpdated('save');
       //   if (this.id) {
       //     this.viewService.saveViewData("/" + this.type + "/" + this.id, { data: this.view_data }).subscribe(d => this.view_data = {});
       //   } else {
       //     this.viewService.saveViewData("/" + this.parent.type + "/" + this.parent.id, { data: this.view_data }).subscribe(d => this.view_data = {});
       //   }
     }
     */
  }

  getVersion (version) {
    this.version = version;
    this.getViews();

  }



  private resetSocket () {
    this.socketService.close(this.socketConnectionId);
    this.userService.isLoggedIn().subscribe(
      (loggedIn) => {
        if (loggedIn) {
          this.updateSocket = this.socketService.connect();
          this.setSocketListener();
        }
      });

  }

  private refreshSocket () {
    if (moment().isAfter(this.socketExpiration)) {
      this.resetSocket();
    }
  }

  private setSocketListener () {
    this.updateSocket.subscribe(event => {
      if (event.type == 'open') {
        // Wait for the socket to tell us there is an open connection
        // Send course id so queue knows what we're listening for
        var setListener = {
          "action": "setlistener",
          "data": {
            'type': 'data',
            'dataId': this.id,
            'user-pool-id': environment.cognitoUserPoolId,
            'client-id': environment.cognitoClientId,
            'sub-domain': environment.domain
          }
        };
        this.updateSocket.next(setListener);

        this.socketExpiration = moment().add(7, 'minutes');

      } else if (event.type == 'message') {
        var data = event.data.replace(/'/g, '"');
        var message = JSON.parse(data);

        if (message['Status'] == 'Listener set.') {
          this.socketConnectionId = message['Connection'];
        } else if (message['Update']) {
          // var snackConfig = {}
          // if (message['Error']) {
          //     snackConfig['panelClass'] = 'snack-error'
          // }

          // this.snackBar.open(message['Update'], 'X', snackConfig)

          this.updateStatusService.setStatus('COMPLETED', message['Update'], message['Error']);

        }
      }
    });
  }

  //removed data refrence to allow saving without cyclical refrence
  searchChildrenForDataRef (data) {
    console.log(data);
    if (data.data_object_ref)
      delete data.data_object_ref;
    Object.keys(data).forEach(key => {
      if (typeof data[key] == 'object') {
        this.searchChildrenForDataRef(data[key]);
      }
    });
  }


  showPageButtons () {
    return (this.showVersions && (this.view && this.view.versions && this.view.versions.length > 0)) ||
      this.showEdit ||
      this.checkKeys(this.view_data);
  }

  updateOverrideView () {
    let settings: any = {
      context: {
        data: {
          title: "Override View?",
          message: "Are you sure you want to override this view? Any custimzations you've made will need to be re-applied."
        }
      }
    };
    let dialogRef = this.dialog.open(ConfirmDialog, settings);

    dialogRef.onClose.subscribe(result => {
      console.log(result);
      if (result && this.overriddenView) {
        this.viewService.updateOverrideView(this.id).subscribe(newView => {
          this.getViews();
        });

      }
    });
  }

  toggleVersion () {
    if (this.versionSidebar) {
      this.versionSidebar.close();
      return null;
    }
    let config = {
      //[id]="info.id" [type]="info.type"
      context: {
        id: this.id,
        type: this.type
      }
    };
    this.versionSidebar = this.sidebar.open(VersionSidebarComponent, config);
    this.versionSidebar.onClose.subscribe(e => {
      this.versionSidebar = null;
    });
  }

}
